import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./globals.css";
import NotFound from "./pages/NotFound";

import { UserConfigProvider } from "./contexts/UserConfigContext";
import AuthPage from "./pages/AuthPage";
import Promote from "./pages/Promote";
import AdminCafeFormPage from "./pages/admin/AdminCafeFormPage";
import AdminCafePage from "./pages/admin/AdminCafePage";
import AnnouncementFormPage from "./pages/admin/AnnouncementFormPage";
import AnnouncementPage from "./pages/admin/AnnouncementPage";
import AudioFormPage from "./pages/admin/AudioFormPage";
import AudioPage from "./pages/admin/AudioPage";
import BulletinFormPage from "./pages/admin/BulletinFormPage";
import BulletinPage from "./pages/admin/BulletinPage";
import CampaignEmailFormPage from "./pages/admin/CampaignEmailFormPage";
import CampaignEmailPage from "./pages/admin/CampaignEmailPage";
import CampaignGroupFormPage from "./pages/admin/CampaignGroupFormPage";
import CampaignGroupPage from "./pages/admin/CampaignGroupPage";
import CampaignPushFormPage from "./pages/admin/CampaignPushFormPage";
import CampaignPushPage from "./pages/admin/CampaignPushPage";
import CommerceProductViewPage from "./pages/admin/CommerceProductViewPage";
import CommerceProductsPage from "./pages/admin/CommerceProductsPage";
import ContactFormPage from "./pages/admin/ContactFormPage";
import ContactPage from "./pages/admin/ContactPage";
import DiscipleGroupClustersFormPage from "./pages/admin/DiscipleGroupClustersFormPage";
import DiscipleGroupClustersPage from "./pages/admin/DiscipleGroupClustersPage";
import DiscipleGroupFormPage from "./pages/admin/DiscipleGroupFormPage";
import DiscipleGroupPage from "./pages/admin/DiscipleGroupPage";
import EventFormPage from "./pages/admin/EventFormPage";
import EventPage from "./pages/admin/EventPage";
import GalleryPage from "./pages/admin/GalleryPage";
import HomePage from "./pages/admin/HomePage";
import LibraryFormPage from "./pages/admin/LibraryFormPage";
import LibraryLoanRecordsPage from "./pages/admin/LibraryLoanRecordsPage";
import LibraryPage from "./pages/admin/LibraryPage";
import MembersFormPage from "./pages/admin/MembersFormPage";
import MembersPage from "./pages/admin/MembersPage";
import MinistryFormPage from "./pages/admin/MinistryFormPage";
import MinistryPage from "./pages/admin/MinistryPage";
import StaffPage from "./pages/admin/StaffPage";
import StaffFormPage from "./pages/admin/StaffFormPage";
import MissionsFormPage from "./pages/admin/MissionsFormPage";
import MissionsPage from "./pages/admin/MissionsPage";
import PlanFormPage from "./pages/admin/PlanFormPage";
import PlanPage from "./pages/admin/PlanPage";
import PrayerFormPage from "./pages/admin/PrayerFormPage";
import PrayerPage from "./pages/admin/PrayerPage";
import PrayerSupportPage from "./pages/admin/PrayerSupportPage";
import ResourcesFormPage from "./pages/admin/ResourcesFormPage";
import ResourcesPage from "./pages/admin/ResourcesPage";
import RolePermissionFormPage from "./pages/admin/RolePermissionFormPage";
import RolePermissionPage from "./pages/admin/RolePermissionPage";
import ServicesFormPage from "./pages/admin/ServicesFormPage";
import ServicesPage from "./pages/admin/ServicesPage";
import SettingsPage from "./pages/admin/SettingsPage";
import SpecialServicesFormPage from "./pages/admin/SpecialServicesFormPage";
import SpecialServicesPage from "./pages/admin/SpecialServicesPage";
import TithingPage from "./pages/admin/TithingPage";
import TithingStatusPage from "./pages/public/TithingStatusPage";
import AppRedirectPage from "./pages/user/AppRedirectPage";
import MemberHomePage from "./pages/user/MemberHomePage";
import MissionsGlobePage from "./pages/user/MissionsGlobePage";
import AccountsPage from "./pages/admin/AccountsPage";
import AccountsFormPage from "./pages/admin/AccountsFormPage";
import ClaimsFormPage from "./pages/admin/ClaimsFormPage";
import ClaimsPage from "./pages/admin/ClaimsPage";
import LocationsPage from "./pages/admin/LocationsPage";
import LocationFormPage from "./pages/admin/LocationFormPage";
import FacilityBookingsPage from "./pages/admin/FacilityBookingsPage";
import FacilityBookingFormPage from "./pages/admin/FacilityBookingFormPage";
import LocationReportsPage from "./pages/admin/LocationReportsPage";
import LocationReportFormPage from "./pages/admin/LocationReportFormPage";
import WebsitePoliciesPage from "./pages/admin/WebsitePoliciesPage";
import WebsitePolicyFormPage from "./pages/admin/WebsitePolicyFormPage";
import EmailNewsletterPage from "./pages/admin/EmailNewsletterPage";
import EmailNewsletterFormPage from "./pages/admin/EmailNewsletterFormPage";

function App() {
  return (
    <UserConfigProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<AuthPage pageState={"login"} />} />
          {/* <Route path="/about" element={<About />} />
        <Route path="/our-pastors-staff" element={<StaffMembers />} />
        <Route path="/missions-release" element={<MissionRelease />} />
        <Route path="/getting-here" element={<GettingToBMC />} />
        <Route path="/online-services" element={<OnlineServices />} />
        <Route path="/sermon-series" element={<SermonSeries />} />
        <Route path="/sermon-series/gospel-of-matthew" element={<SermonSeriesMatthew />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/whatsapp" element={<Whatsapp />} />
        <Route path="/traditional" element={<OnlineServicesTraditional />} />
        <Route path="/chinese" element={<OnlineServicesChinese />} />
        <Route path="/tithes" element={<Tithes />} />
        <Route path="/missions-opportunities" element={<MissionsOpportunities />} />
        <Route path="/new" element={<New />} />
        <Route path="/ministries" element={<AllMinistries />} />
        <Route path="/featured-item/:item" element={<FeaturedItem />} />
        <Route path="/whistle-blowing-policy" element={<WhistleBlowingPolicy />} />
        <Route path="/site-map" element={<SiteMap />} />
        <Route path="/announcements" element={<Announcements />} />
        <Route path="/announcements/:topic" element={<News />} /> */}
          {/* <Route path="/prayer-requests" element={<PrayerSupport />} /> */}


          <Route path="/auth/login" element={<AuthPage pageState={"login"} />} />
          <Route path="/auth/register" element={<AuthPage pageState={"register"} />} />
          <Route path="/auth/recovery" element={<AuthPage pageState={"recovery"} />} />
          <Route path="/auth/recovery/verify" element={<AuthPage pageState={"reset"} />} />
          <Route path="/tithing" element={<TithingStatusPage />} />
          <Route path="/bmcplus" element={<Promote />} />
          <Route path="/app/:url" element={<AppRedirectPage />} />

          {/* Missions */}
          <Route path="/missions/globe" element={<MissionsGlobePage />} />

          {/* User */}
          <Route path="/home" element={<MemberHomePage />} />


          {/* Admin Dashboard */}
          <Route path="/admin" element={<HomePage />} />
          <Route path="/admin/library" element={<LibraryPage />} />
          <Route path="/admin/library/loan" element={<LibraryLoanRecordsPage />} />
          <Route path="/admin/library/details" element={<LibraryFormPage />} />
          <Route path="/admin/missions" element={<MissionsPage />} />
          <Route path="/admin/missions/details" element={<MissionsFormPage />} />
          <Route path="/admin/settings" element={<SettingsPage />} />
          <Route path="/admin/commerce/products" element={<CommerceProductsPage />} />
          <Route path="/admin/commerce/products/:id" element={<CommerceProductViewPage />} />
          <Route path="/admin/services" element={<ServicesPage />} />
          <Route path="/admin/services/details" element={<ServicesFormPage />} />
          <Route path="/admin/contact" element={<ContactPage />} />
          <Route path="/admin/contact/details" element={<ContactFormPage />} />
          <Route path="/admin/special/services" element={<SpecialServicesPage />} />
          <Route path="/admin/special/services/details" element={<SpecialServicesFormPage />} />
          <Route path="/admin/events" element={<EventPage />} />
          <Route path="/admin/events/details" element={<EventFormPage />} />
          <Route path="/admin/bulletin" element={<BulletinPage />} />
          <Route path="/admin/bulletin/details" element={<BulletinFormPage />} />
          <Route path="/admin/tithing" element={<TithingPage />} />
          <Route path="/admin/announcements" element={<AnnouncementPage />} />
          <Route path="/admin/announcements/details" element={<AnnouncementFormPage />} />
          <Route path="/admin/plan" element={<PlanPage />} />
          <Route path="/admin/plan/details" element={<PlanFormPage />} />
          <Route path="/admin/prayer" element={<PrayerPage />} />
          <Route path="/admin/prayer/details" element={<PrayerFormPage />} />
          <Route path="/admin/prayer/support" element={<PrayerSupportPage />} />
          <Route path="/admin/users" element={<MembersPage />} />
          <Route path="/admin/users/details" element={<MembersFormPage />} />
          <Route path="/admin/roles-permissions" element={<RolePermissionPage />} />
          <Route path="/admin/roles-permissions/details" element={<RolePermissionFormPage />} />
          <Route path="/admin/ministry" element={<MinistryPage />} />
          <Route path="/admin/ministry/details" element={<MinistryFormPage />} />
          <Route path="/admin/staff" element={<StaffPage />} />
          <Route path="/admin/staff/details" element={<StaffFormPage />} />
          <Route path="/admin/audio" element={<AudioPage />} />
          <Route path="/admin/audio/details" element={<AudioFormPage />} />
          <Route path="/admin/gallery" element={<GalleryPage />} />
          <Route path="/admin/dg" element={<DiscipleGroupPage />} />
          <Route path="/admin/dg/details" element={<DiscipleGroupFormPage />} />
          <Route path="/admin/dg/clusters" element={<DiscipleGroupClustersPage />} />
          <Route path="/admin/dg/clusters/details" element={<DiscipleGroupClustersFormPage />} />
          <Route path="/admin/resources" element={<ResourcesPage />} />
          <Route path="/admin/resources/details" element={<ResourcesFormPage />} />
          <Route path="/admin/cafe" element={<AdminCafePage />} />
          <Route path="/admin/cafe/details" element={<AdminCafeFormPage />} />
          <Route path="/admin/campaigns/push" element={<CampaignPushPage />} />
          <Route path="/admin/campaigns/push/details" element={<CampaignPushFormPage />} />
          <Route path="/admin/campaigns/email" element={<CampaignEmailPage />} />
          <Route path="/admin/campaigns/email/details" element={<CampaignEmailFormPage />} />
          <Route path="/admin/campaigns/groups-tags" element={<CampaignGroupPage />} />
          <Route path="/admin/campaigns/groups-tags/details" element={<CampaignGroupFormPage />} />
          <Route path="/admin/accounts" element={<AccountsPage />} />
          <Route path="/admin/accounts/details" element={<AccountsFormPage />} />
          <Route path="/admin/claims" element={<ClaimsPage />} />
          <Route path="/admin/claims/details" element={<ClaimsFormPage />} />
          <Route path="/admin/locations" element={<LocationsPage />} />
          <Route path="/admin/locations/details" element={<LocationFormPage />} />
          <Route path="/admin/locations/bookings" element={<FacilityBookingsPage />} />
          <Route path="/admin/locations/bookings/details" element={<FacilityBookingFormPage />} />
          <Route path="/admin/locations/bookings/approve" element={<FacilityBookingFormPage />} />
          <Route path="/admin/locations/reports" element={<LocationReportsPage />} />
          <Route path="/admin/locations/reports/details" element={<LocationReportFormPage />} />
          <Route path="/admin/website/policies" element={<WebsitePoliciesPage />} />
          <Route path="/admin/website/policies/details" element={<WebsitePolicyFormPage />} />
          <Route path="/admin/campaigns/email-newsletter" element={<EmailNewsletterPage />} />
          <Route path="/admin/campaigns/email-newsletter/details" element={<EmailNewsletterFormPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </UserConfigProvider>
  );
}

export default App;
